import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { useAuthState } from '../context'
import { resetAuthState, userLoggedIn } from '../actions'
import jwtDecode from 'jwt-decode'
import useUserManager from '../useUserManager'
import { setOidcUser } from '../refreshAccessToken'
import { useTranslation } from 'react-i18next'
function LoginCallback({ history, render }) {
    const { t } = useTranslation()
    const [{ extractAuthData }, dispatch] = useAuthState()
    const userManager = useUserManager()
    const callbackProcessed = useRef(false)
    const [authError, setAuthError] = useState(null)

    useEffect(() => {
        const signedIn = async (user) => {
            const decodedAccessToken = jwtDecode(user.access_token)

            const userAuthData = await extractAuthData(
                user.access_token,
                decodedAccessToken,
            )

            const newExpiresAt = decodedAccessToken.exp
                ? decodedAccessToken.exp
                : user.expires_at

            setOidcUser(userManager, {
                ...user,
                expires_at: newExpiresAt,
            })

            dispatch(
                userLoggedIn({
                    accessToken: user.access_token,
                    idToken: user.id_token,
                    ...userAuthData,
                }),
            )

            if (user.state) {
                history.push(user.state.from)
            } else {
                history.push('/')
            }
        }

        const func = async () => {
            if (callbackProcessed.current) return
            callbackProcessed.current = true

            dispatch(resetAuthState())

            try {
                const urlParams = new URLSearchParams(window.location.search)
                const error = urlParams.get('error')
                const errorDescription = urlParams.get('error_description')

                if (error) {
                    setAuthError({
                        error,
                        errorDescription,
                    })
                    return
                }
                const user = await userManager.signinRedirectCallback()
                if (user) await signedIn(user)
            } catch (error) {
                console.error('Authentication error:', error)
                const existingUser = await userManager.getUser()
                if (existingUser) {
                    await signedIn(existingUser)
                } else {
                    setAuthError({
                        error: 'authentication_failed',
                        errorDescription:
                            error.message ||
                            'Authentication failed. Please try again.',
                    })
                }
            }
        }

        func()
    }, [dispatch, history])

    if (authError) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '20px',
                    textAlign: 'center',
                }}
            >
                <h1
                    style={{
                        color: '#d32f2f',
                        marginBottom: '20px',
                    }}
                >
                    {authError.error}
                </h1>
                <p
                    style={{
                        fontSize: '16px',
                        color: '#666',
                        maxWidth: '600px',
                        lineHeight: '1.5',
                    }}
                >
                    {authError.errorDescription}
                </p>
                <button
                    onClick={() => history.push('/signin')}
                    sx={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                >
                    {t('Login')}
                </button>
            </div>
        )
    }

    return render()
}

LoginCallback.propTypes = {
    render: PropTypes.func.isRequired,
}

export default withRouter(LoginCallback)
